import { Button, Dropdown, Menu } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getEditorMenuItems, getTableMenuItems } from './EditorMenuItems';

import Bold from './editor-buttons/Bold';
import Italic from './editor-buttons/Italic';
import Underline from './editor-buttons/Underline';
import Strikethrough from './editor-buttons/Strikethrough';
import BulletedList from './editor-buttons/BulletedList';
import NumberedList from './editor-buttons/NumberedList';
import Quote from './editor-buttons/Quote';
import AlignLeft from './editor-buttons/AlignLeft';
import AlignCenter from './editor-buttons/AlignCenter';
import AlignRight from './editor-buttons/AlignRight';
import AlignJustify from './editor-buttons/AlignJustify';
import Link from './editor-buttons/Link';

const TextEditorToolbar = ({ entityId, entityType, editor, linkEditorComponentId, showImageOption, showMentionOptions }) => {
  if (!editor) return null;

  const isInTable = editor.isActive('table');

  const menu = (
    <Menu
      className="editor-toolbar-menu"
      items={isInTable ? getTableMenuItems({ editor }) : getEditorMenuItems({ entityId, entityType, editor, linkEditorComponentId, showImageOption, showMentionOptions })}
      style={{ maxHeight: '300px', overflowY: 'auto' }}
    />
  );

  return (
    <div className="flex flex-wrap items-center pb-1">
      <Dropdown
        trigger={['click']}
        placement="bottomLeft"
        dropdownRender={() => (
          <div className="min-w-[200px]">
            {menu}
          </div>
        )}
      >
        <Button
          icon={<PlusOutlined className="text-gray-800 text-[12px]" />}
          type="text"
          size="small"
          className="hover:bg-slate-100 !bg-transparent"
        />
      </Dropdown>
      <Bold editor={editor} />
      <Italic editor={editor} />
      <Underline editor={editor} />
      <Strikethrough editor={editor} />
      <BulletedList editor={editor} />
      <NumberedList editor={editor} />
      <Quote editor={editor} />
      <div className="text-editor-vertical-divider" />
      <AlignLeft editor={editor} />
      <AlignCenter editor={editor} />
      <AlignRight editor={editor} />
      <AlignJustify editor={editor} />
      <div className="text-editor-vertical-divider" />
      <Link editor={editor} linkEditorComponentId={linkEditorComponentId}/>
    </div>
  );
};

export default TextEditorToolbar;
